import React from 'react';
import { CopyableBlock } from '../CopyableBlock';

export const WhatsAppOutputs = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="output-whatsapp">
      <CopyableBlock label="50-word version" content={data.fifty_word} testId="wa-50" />
      <CopyableBlock label="100-word version" content={data.hundred_word} testId="wa-100" />
      <CopyableBlock label="Broadcast format" content={data.broadcast} testId="wa-broadcast" />
      <CopyableBlock label="Associate-forward format" content={data.associate_forward} testId="wa-forward" />
      <CopyableBlock label="Community group format" content={data.community_group} testId="wa-community" />
    </div>
  );
};

export default WhatsAppOutputs;
